import { ServerResponse } from '../../lib/classes/serverResponse';
import { FinnAdvertisement } from '../../lib/classes/finn/finnAdvertisement';

export class JobSourcing {
  id: number;
  job_boards: JobBoard[];
  publisher_is_draft: boolean;
  publisher_is_published: boolean;
  publisher_linked_id: number;
  publisher_modified_mt: Date;
  created_at: Date;
  updated_at: Date;
  job_id: number;
}

export class EquestBoard {
  draft_id: number;
  requisition_number: number;
}

export class JobBoard {
  id: number;
  job_board_specification: JobBoardSpecification;
  job_board_specification_id: number;
  finn_ad: FinnAdvertisement;
  equest_board: EquestBoard;
  created_at: Date;
  updated_at: Date;
  enabled: boolean;
  configured: boolean;
  order_line: OrderLine;
  order_line_id: number;
  job_sourcing_id: number;
}

export class OrderLine extends ServerResponse {
  public id: number;
  public product: Product;
  public unit_price: number;
  public quantity: number;
  public amount: number;
}

export class JobBoardSpecification {
  id: number;
  product: Product;
  product_id: number;
  provider: Provider;
  can_be_added_many_times: boolean;
}

export class Product {
  id: number;
  name: string;
  description: string;
  code: string;
  image: string;
  amount: number;
  active: boolean;
  enable_by_default: boolean;
}

export enum Provider {
  GOOGLE = 'google',
  FINN = 'finn',
  FINN_WITH_SUPPORT = 'finn_support',
  NAV = 'nav',
  EQUEST = 'equest',
  INDEED = 'indeed',
  MOJOB_SOCIAL_MEDIA_BOOST = 'mojob_social_media_boost',
  MOJOB_FEED = 'mojob_feed',
  MOJOB_CAREER_PAGE = 'mojob_career_page',
}
